
import './house.css'
import Galeriehouse from '../../galeriehouse'

const House = () => {
    
    
    return (
        <div className="house">
            <Galeriehouse/>
           
        </div>
)
    
}

export default House